<template>
  <!-- Video preview form -->
  <modal :visible="visible" :title="title" can-close @close="close">
    <template v-slot:body>
      <audio ref="player" :src="link" controls />
    </template>
  </modal>
</template>

<script>
import Modal from "@/components/dialog/Modal.vue";

// @group Dialog
// Audio player modal
export default {
  name: "AudioWatchModal",
  components: {
    Modal
  },
  props: {
    /** Is modal visible */
    visible: {
      type: Boolean,
      default: true
    },
    /** Audio title */
    name: {
      type: String,
      default: "No name"
    },
    /** Audio link */
    link: {
      type: String,
      default: ''
    }
  },
  computed: {
    // @vuese
    // Modal title
    title() {
      return `Audio preview: ${this.name}`;
    }
  },
  watch: {
    // @vuese
    // Stop player when modal is closed
    visible() {
      if (this.$refs.player && !this.visible) {
        this.$refs.player.pause();
      }
    }
  },
  methods: {
    // @vuese
    // Close modal
    close() {
      this.$emit("close");
    }
  }
};
</script>
